import { render, staticRenderFns } from "./indexDr.vue?vue&type=template&id=13c4ae98&scoped=true&"
import script from "./indexDr.vue?vue&type=script&lang=js&"
export * from "./indexDr.vue?vue&type=script&lang=js&"
import style0 from "./indexDr.vue?vue&type=style&index=0&id=13c4ae98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4ae98",
  null
  
)

export default component.exports